<template>
  <div class="main">
    <div class="main-top">
      <div class="images"></div>
      <p class="text fwb">POCKET</p>
    </div>
    <div class="title">
      <p class="fwb">Pocket</p>
      <p>元宇宙语音社交平台</p>
    </div>
    <div class="download">
      <div v-if="status" @click="downloadBtn(3)" class="mr28"><img src="../../assets/pc/admin1.svg" alt=""></div>
      <div v-if="status"  @click="downloadBtn(2)" class="mr28"><img src="../../assets/pc/admin2.svg" alt=""></div>
      <div @click="downloadBtn(1)" class="mr28"><img src="../../assets/pc/admin3.svg" alt=""></div>
      <div v-if="!status" @click="downloadBtn(2)" class="mr28"><img src="../../assets/pc/admin2.svg" alt=""></div>
      <div v-if="!status"  @click="downloadBtn(3)"><img src="../../assets/pc/admin1.svg" alt=""></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "index",
  components: {
  },
  data() {
    return {
      status:false,  //pc端
      isAndroidUrl:'https://test-1302052317.cos.ap-chengdu.myqcloud.com/download/pocket_cn.apk',
      isIosUrl:'https://apps.apple.com/cn/app/pocket-avatar-voice-live/id1523009207',
      googleUrl:' https://play.google.com/store/apps/details?id=com.sy.pocket',
      //移动端
      // isAndroidPcUrl:'',
      // isIosPcUrl:'',
      // googlePcUrl:''
    };
  },
  created() {
    if (this._isMobile()) {
      this.status = true
    } else {
      this.status = false
    }
  },
  mounted() {

  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },

    downloadBtn(e) {
        if(e == 1){
        window.location.href = this.isAndroidUrl
        }
        if(e == 2){
          window.location.href = this.isIosUrl
        }
        if(e == 3){
          window.location.href = this.googleUrl
        }
    }
  },
};

</script>

<style scoped>
* {
  padding: 0;
  margin: 0;
}
.main {
  height: 100%;
  background-image: url("../../assets/background.jpg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
@media screen and (max-width: 767px) {
  .main-top {
    display: flex;
    align-items: center;
    padding-left: 10px;
  }

  .images {
    width: 50px;
    height: 60px;
    background-image: url("../../assets/download/icon.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: 0px 9px;
  }

  .text {
    color: #ffff;
    font-size: 22px;
    margin-left: 20px;
  }

  .title {
    font-size: 30px;
    color: #ffff;
    margin-top: 50px;
    margin-left: 25px;
    line-height: 50px;
  }

  .download {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 160px;
  }

  .fwb {
    font-weight: bold;
  }
}
@media screen and (min-width: 768px) {
  .main-top {
    width: 400px;
    height: 90px;
    display: flex;
    align-items: center;
    margin-left: 60px;

  }

  .images {
    width: 70px;
    height: 90px;
    background-image: url("../../assets/download/icon.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: 0px 13px;

  }

  .text {
    color: #ffff;
    font-size: 30px;
    margin-left: 20px;
  }

  .title {
    font-size: 60px;
    color: #ffff;
    margin-left: 110px;
    margin-top: 200px;
    line-height: 100px;
  }

  .download {
    margin-left: 60px;
    margin-top: 145px;
    display: flex;
    cursor: pointer;
  }

  .download img {
    width: 210px;
    height: 64px;
  }

  .fwb {
    font-weight: bold;
  }

  .mr28 {
    margin-right: 28px;
  }

}
@media screen and (min-width: 992px) {
  .main-top {
    margin-left: 100px;

  }
  .title {
    margin-left: 275px;
  }
  .download {
    margin-left: 275px;
  }
}
</style>